<template>
    <div>
        <div class="navbar" :style="{ paddingTop: titlePadding + 'px' }">
            <van-nav-bar
                class="navbar"
                title="选择联系人"
                left-arrow
                @click-left="$router.go(-1)"
                />
                <div class="search-box">
                    <van-search v-model="searchKey" @search="onSearch" placeholder="联系人姓名" />
                </div>
        </div>
        <div class="pagebody" :style="{ paddingTop: titlePadding + 110 + 'px' }">
            <van-list
                class="datalist"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                >
                <div @click="selectHandle(item)" class="data-item" v-for="(item, index) in dataList" :key="item.mobile">
                    <!-- 复选框 -->
                    <div class="checkbox">
                        <img v-if="item.isselect" src="@/assets/instantMessaging/checkbox.png" alt="">
                        <img v-if="!item.isselect" src="@/assets/instantMessaging/checkbox(2).png" alt="">
                    </div>
                    <!-- <img class="avatar" :src="item.avatar" alt=""> -->
                    <img class="avatar" src="@/assets/travelAgency/ic_bm_cy1.png" alt />
                    
                    <div class="info-box">
                        <p class="name">{{ item.name }}</p>
                        <p class="mechanism">{{ item.mobile }}</p>
                        <!-- 没权限 -->
                        <!-- <div class="permission">
                            <img src="@/assets/instantMessaging/warning.png" alt="">
                            <span>该账号无查看此退货单权限</span>
                        </div> -->
                    </div>
                </div>
            </van-list>
        </div>

        <div class="foot">
            <div class="imgbox">
                <span class="yixuan">已选：</span>
                <div class="name-list">
                    <div v-for="(item, index) in selectData" :key="index">{{ item.isselect ? item.name + '、' : '' }}</div>
                </div>
                <!-- <div v-for="(item, index) in dataList" :key="index"> -->
                    <!-- <img v-if="item.isselect" :src="item.avatar" alt=""> -->
                <!-- </div> -->
            </div>
            <div @click="confirm" class="btn">确定</div>
        </div>
    </div>
</template>

<script>
import TIM from 'tim-js-sdk/tim-js-friendship'
import api from 'apis';
import Vue from 'vue';
import { NavBar } from 'vant';
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import instantMessagingApi from '../../../../service/modules/instantMessaging'

Vue.use(NavBar);

export default {
    data() {
        return {
		    titlePadding: 40,
            searchKey: '',
            loading: false,
            finished: true,
            dataList: [
                // {name: 'zhangs465an', mechanism: '无花456无', isselect: true, avatar: 'https://img0.baidu.com/it/u=3293218222,3770083333&fm=253&fmt=auto&app=138&f=PNG?w=500&h=537'},
                // {name: 'zhangs465an', mechanism: '无花456无', isselect: true, avatar: 'https://img0.baidu.com/it/u=3293218222,3770083333&fm=253&fmt=auto&app=138&f=PNG?w=500&h=537'},
                // {name: 'zhangs465an', mechanism: '无花456无', isselect: true, avatar: 'https://img0.baidu.com/it/u=3293218222,3770083333&fm=253&fmt=auto&app=138&f=PNG?w=500&h=537'},
                // {name: 'zhangsan', mechanism: '无花无', isselect: false, avatar: 'https://img2.baidu.com/it/u=3379935834,2112170361&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500'},
            ],
            selectData: [],
            chatType: ''
        }
    },
    created() {
		this.setTitlePadding();
        // this.getData()
            console.log('jjjjjjjjjj', this.detail);

    },
    beforeRouteEnter(to, from, next) {
        console.log('7777777', from);
        if (from.path === '/instantMessaging/chatInterface') {
            next(vm => {
                vm.chatType = 'chatInterface'
            })
        } else {
            next(vm => {
                vm.chatType = 'personalChat'
            })
        }
    },
    computed: {
        ...mapState('refund', ['detail', 'userInfo',]),
        ...mapState('instantMessaging', [
	        'currentUserProfile',
              'currentConversation'
            ]),
        ...mapState('home', ['keyword', 'currentUserInfo']),
        ...mapGetters('instantMessaging', [
                'toAccount',
                'currentConversationType',
                'isC2C'
            ]),
        currentUserId: function () {
                return `yjg_${this.userInfo.id}`;
            },
        refundId: function () {
            // if (!this.detail) {
            //     return null;
            // }
            const refundId = localStorage.getItem('refundId')
            return refundId
        },
        currentUserInfo () {
                return this.$store.state.home['currentUserInfo']
            },
    },
    methods: {
        ...mapActions("instantMessaging", ['getGroupMemberList']),
        ...mapMutations('instantMessaging', [
                'pushCurrentMessageList',
            ]),
        onSearch() {
          this.getData()
        },
        getData() {
            this.loading = true;

            const data = {
                keywords: this.searchKey
            };
            api.searchaddressbook(data).then(res => {
                console.log('联系人列表', res)
                if (res.ret === 0) {
                    this.loading = false;
                    this.finished = true
                    this.dataList = res.data.contacts
                    this.dataList.forEach((i, index) => {
                        i['isselect'] = false
                        this.selectData.forEach(i2 => {
                            i.mobile == i2.mobile && (i.isselect = true)
                        })
                    })
                } else {
                    this.loading = false;
                    this.dataList = []
                }
            })
        },
        async confirm() {
            if (this.selectData.length === 0) {
                return this.$toast('您还未选择人员');
            }
            const memberList = [];

            const memberNameList = []
            
            await this.selectData.map(item => {

                memberNameList.push(item.name)

                instantMessagingApi.importAccount({
                    nick: item.name,
                    identifier: `yjg_${item.staffCode}`
                });


                memberList.push({
                    memberAccount: `yjg_${item.staffCode}`,
                    appMemberDefinedData: [
                        {
                            key: 'Role_Name',
                            value: item.name
                        }
                    ]
                })
            })
            // chatInterface为工单聊天，工单聊天都是群聊，直接添加群成员
            if (this.chatType === 'chatInterface') {

                const addMembersRes = instantMessagingApi.addMembersWithInfo({
                    groupId: this.refundId,
                    memberList
                })
                addMembersRes.then(res => {
                    console.log('res', res);
                    if (res.ret === 0) {
                        this.$toast(res.data.msg);
                          // tim发送邀请消息
                    this.sendInvitationNotification(memberNameList)
                     setTimeout(() => {
                        this.$router.go(-1)
                    }, 1500)
                    }
                })
                
            } else {
                if (this.currentConversationType === 'C2C') {
                    // 如果是单聊进来并且目前不是tim群聊就创建群聊
                    this.timCreateGroup(memberNameList)
                } else {
                    // 如果已经是群聊则添加成员
                    this.addGroupMember(memberNameList)
                }
            }

           
        },
        // tim创建群聊
        timCreateGroup(memberNameList) {

            const GroupMember = []
            // 添加选中的成员
            this.selectData.map(i => {
                GroupMember.push({
                    userID: `yjg_${i.staffCode}`
                })
            })

        
        //   添加单聊的双方
          GroupMember.push({
            userID: `yjg_${this.currentUserInfo.staffCode}`
          })

          GroupMember.push({
            userID: `${this.currentConversation.userProfile.userID}`
          })
          console.log('888888888', GroupMember);
            // 如果不是群聊tim创建群聊
            let promise = this.tim.createGroup({
                type: TIM.TYPES.GRP_WORK,
                // name: `与${this.currentConversation.userProfile.nick}等人的群聊`,
                name: `与${this.currentConversation.userProfile.nick.substr(0, 4)}等人的群聊`,
                groupID: `TIO-${Date.now()}`,
                memberList: GroupMember// 如果填写了 memberList，则必须填写 userID
            });
            promise.then((imResponse) => { // 创建成功
                 // tim发送邀请消息
            // this.sendInvitationNotification(memberNameList)
              console.log('创建群聊成功--------', imResponse.data.group); // 创建的群的资料
                this.$toast('创建群聊成功')
                console.log('5555555', typeof imResponse.groupID);

                 this.$router.push({
                  path: `/personalChat`,
                  query: {
                    targetId: imResponse.data.group.groupID.replace('TIO-', ''),
                    currentConversationType: 'GROUP',
                    userId: this.currentUserInfo.staffCode,
                  }
                })
                


            }).catch(function(imError) {
                this.$toast('创建失败')
              console.warn('创建群聊失败--------', imError); // 创建群组失败的相关信息
            });
        },
        // 添加群成员
        addGroupMember(memberNameList) {

            const userIDList = []

            this.selectData.map(i => {
                userIDList.push(`yjg_${i.staffCode}`)
            })

            // console.log('userIDListuserIDListuserIDListuserIDList', userIDList);
            const groupID = this.currentConversation.groupProfile.groupID
            // console.log('888888888888', groupID);
            let promise = this.tim.addGroupMember({groupID: groupID, userIDList: userIDList});
                promise.then(async(imResponse) => {
                             // tim发送邀请消息
                    this.sendInvitationNotification(memberNameList)
                    
                    this.$toast('邀请成功')

                    setTimeout(() => {
                        // this.$router.push('/mailLList')
                        this.$router.go(-1)
                    }, 1500)
                    // console.log(imResponse.data.successUserIDList); // 添加成功的群成员 userIDList
                    // console.log(imResponse.data.failureUserIDList); // 添加失败的群成员 userIDList
                    console.log('已在群中的群成员', imResponse.data.existedUserIDList); // 已在群中的群成员 userIDList
                    // 一个用户 userX 最多允许加入 N 个群，如果已经加入了 N 个群，此时再尝试添加 userX 为群成员，则 userX 不能正常加群
                    // SDK 将 userX 的信息放入 overLimitUserIDList，供接入侧处理
                    // console.log(imResponse.data.overLimitUserIDList); // 超过了“单个用户可加入群组数”限制的用户列表，v2.10.2起支持
                    // console.log(imResponse.data.group); // 添加后的群组信息
                }).catch(function(imError) {
                    console.warn('addGroupMember error:', imError); // 错误信息
                });
        },
        // tim发送邀请通知
        sendInvitationNotification(memberNameList) {
            const str = memberNameList.join('、')
            const message = this.tim.createCustomMessage({
                to: this.toAccount,
                conversationType: this.currentConversationType,
                payload: {
                    data: 'inviteGroupChat',
                    description: JSON.stringify({
                        userId: this.currentUserProfile.userID,
                        groupId: this.toAccount
                    }),
                    extension: str
                }
            })

            this.pushCurrentMessageList(message);


            this.tim.sendMessage(message).catch(error => {
                this.showMessage({
                    type: 'danger',
                    message: error.message
                })
            });
        },
        selectHandle(item) {
            item.isselect = !item.isselect
            let index = this.selectData.findIndex(i => i.mobile === item.mobile)
            if (item.isselect) {
                if (index !== -1) {
                    this.selectData[index]['isselect'] = true
                } else {
                    this.selectData.push(item)
                }
            } else {
                if (index !== -1) {
                    this.selectData.splice(index, 1)
                }
            }
        },
        onLoad() {

        },
         setTitlePadding() {
		    let u = navigator.userAgent;
		    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
		    if (isiOS) {
		        this.titlePadding = 30;
		    }
	    }
    }
}
</script>
<style lang="less">
    .navbar {
        position: fixed;
        width: 100%;
        background-color: white;
        z-index: 1;
        /deep/.van-nav-bar__content {
            height: 44px;
        }

        /deep/.van-nav-bar .van-icon {
            color: #333333;
            font-size: 20px;
            font-weight: 500;
        }

        .search-box {
            padding-top: 44px;
            /deep/.van-search {
                padding: 12px 16px;
            }
        }
    }
    .pagebody {
        background: #f5f6f9;
        min-height: 100vh;
        .datalist {
            .data-item {
                display: flex;
                align-items: center;
                padding: 14px 12px;
                background: white;
                .checkbox {
                    margin-right: 9px;
                    img {
                        width: 20px;
                        height: 20px;
                    }
                }
                .avatar {
                    width: 38px;
                    height: 38px;
                    border-radius: 4px;
                    margin-right: 12px;
                }
                .info-box {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .name {
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 400;
                        line-height: 20px;
                        color: #171A1D;
                        margin-bottom: 2px;
                    }
                    .mechanism {
                        font-size: 11px;
                        font-family: PingFang SC;
                        font-weight: 400;
                        line-height: 16px;
                        color: #9DA0A4;
                        margin-bottom: 2px;
                    }
                    .permission {
                        height: 22px;
                        padding: 0 6px;
                        display: flex;
                        align-items: center;
                        background: rgba(255, 159, 63, 0.39);
                        border-radius: 2px;
                        img {
                            width: 10px;
                            height: 10px;
                        }
                        span {
                            font-size: 11px;
                            font-family: PingFang SC;
                            font-weight: 400;
                            line-height: 16px;
                            color: #FA6D5D;
                        }
                    }
                
                }

            }
        }
    }
    .foot {
        position: fixed;
        bottom: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        background: white;
        padding: 13px 16px;
        height: 64px;
        .imgbox {
            display: flex;
        
            .name-list {
                overflow-x: auto;
                display: flex;
                max-width: 240px;
                div {
                    white-space: nowrap;
                }
              
            }

            img{
                width: 38px;
                height: 38px;
                background: rgba(0, 0, 0, 0);
                border-radius: 4px;
                margin-right: 12px;
            }
        }
        
        .btn {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 28px;
            padding: 0 12px;
            background: rgba(54, 179, 116, 1);
            border-radius: 2px;
        }
    }
</style>